import React from 'react';

interface FloatingImportIndicatorProps {
  progress: {
    status: 'queued' | 'processing' | 'completed' | 'failed';
    total: number;
    processed: number;
    inserted: number;
    updated: number;
    failed: number;
  };
  type: 'company' | 'people';
  onClick: () => void;
}

const FloatingImportIndicator: React.FC<FloatingImportIndicatorProps> = ({ 
  progress, 
  type, 
  onClick 
}) => {
  const getProgressPercentage = () => {
    if (!progress || progress.total === 0) return 0;
    return Math.round((progress.processed / progress.total) * 100);
  };

  const getStatusColor = () => {
    if (progress.status === 'completed') return '#2e7d32';
    if (progress.status === 'failed') return '#d32f2f';
    return '#1976d2';
  };

  const getStatusText = () => {
    if (progress.status === 'completed') return 'Completed';
    if (progress.status === 'failed') return 'Failed';
    if (progress.status === 'processing') return 'Processing';
    return 'Queued';
  };

  return (
    <div
      onClick={onClick}
      style={{
        position: 'fixed',
        top: '20px',
        right: '55px',
        minWidth: '200px',
        maxWidth: '300px',
        backgroundColor: '#fff',
        borderRadius: '6px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        cursor: 'pointer',
        zIndex: 1400,
        border: '1px solid #e0e0e0',
        overflow: 'hidden',
      }}
    >
      {/* Progress bar at the top */}
      <div style={{
        width: '100%',
        height: '3px',
        backgroundColor: '#e0e0e0',
      }}>
        <div style={{
          width: `${getProgressPercentage()}%`,
          height: '100%',
          backgroundColor: getStatusColor(),
          transition: 'width 0.3s ease',
        }} />
      </div>

      {/* Content */}
      <div style={{ padding: '10px 12px' }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '6px',
        }}>
          <span style={{
            fontSize: '0.875rem',
            fontWeight: 600,
            color: '#333',
          }}>
            Import {type === 'company' ? 'Companies' : 'People'}
          </span>
          <span style={{
            fontSize: '0.7rem',
            fontWeight: 500,
            padding: '2px 6px',
            borderRadius: '10px',
            backgroundColor: 
              progress.status === 'completed' ? '#c8e6c9' :
              progress.status === 'failed' ? '#ffcdd2' :
              '#bbdefb',
            color:
              progress.status === 'completed' ? '#1b5e20' :
              progress.status === 'failed' ? '#b71c1c' :
              '#0d47a1',
          }}>
            {getStatusText()}
          </span>
        </div>

        {/* Progress text */}
        <div style={{
          fontSize: '0.8rem',
          color: '#666',
          marginBottom: '4px',
        }}>
          {progress.processed} / {progress.total} records ({getProgressPercentage()}%)
        </div>

        {/* Click to expand hint */}
        <div style={{
          fontSize: '0.7rem',
          color: '#999',
        }}>
          Click to view details
        </div>
      </div>
    </div>
  );
};

export default FloatingImportIndicator;

